import React from 'react'
import styles from '../datedlist.module.scss'
import PropTypes from 'prop-types'

const RowDate = ({
  date = null,
  l10n: {
    formatFunction = (dateTimestamp) => dateTimestamp,
    today = 'Today',
    yesterday = 'Yesterday',
    formatDates: { short = 'd MMMM', long = 'd MMMM yyyy' },
  },
}) => {
  const currentYear = new Date().getFullYear()
  const dateTimestamp = date * 1000
  const dateYear = new Date(dateTimestamp).getFullYear()
  const formatDate = dateYear === currentYear ? short : long

  return date ? (
    <div className={styles['dated-list__date']}>
      {formatFunction(dateTimestamp, formatDate, {
        today: `'${today}'`,
        yesterday: `'${yesterday}'`,
      })}
    </div>
  ) : null
}

RowDate.propTypes = {
  date: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  l10n: PropTypes.object,
}

export default RowDate
